export interface StoreLocation {
	id: number;
	name: string;
	streetAddress: string;
	addressLine2?: string | null;
	city: string;
	state: string;
	zip: string;
	country: 'US' | 'CA';
	phone?: string | null;
	website?: string | null;
	hours?: string | null;
	latitude?: number | null;
	longitude?: number | null;
}

export interface LatLng {
	lat: number;
	lng: number;
}

export function hasCoordinates(
	store: StoreLocation,
): store is StoreLocation & { latitude: number; longitude: number } {
	return (
		typeof store.latitude === 'number' &&
		Number.isFinite(store.latitude) &&
		typeof store.longitude === 'number' &&
		Number.isFinite(store.longitude)
	);
}

const EARTH_RADIUS_MILES = 3958.8;

export function distanceMiles(a: LatLng, b: LatLng): number {
	const toRadians = (deg: number) => (deg * Math.PI) / 180;
	const dLat = toRadians(b.lat - a.lat);
	const dLng = toRadians(b.lng - a.lng);
	const sinLat = Math.sin(dLat / 2);
	const sinLng = Math.sin(dLng / 2);
	const h =
		sinLat * sinLat + Math.cos(toRadians(a.lat)) * Math.cos(toRadians(b.lat)) * sinLng * sinLng;
	return 2 * EARTH_RADIUS_MILES * Math.asin(Math.sqrt(h));
}

export function formatStoreAddress(store: StoreLocation): string {
	const line1 = [store.streetAddress, store.addressLine2].filter(Boolean).join(', ');
	return `${line1}, ${store.city}, ${store.state} ${store.zip}`;
}

export function directionsUrl(store: StoreLocation): string {
	const destination = hasCoordinates(store)
		? `${store.latitude},${store.longitude}`
		: formatStoreAddress(store);
	return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
}
